var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-4 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-125.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-marker",
    transform: "translate(78.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z",
    id: "Shape",
    fill: "#d50000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "white",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 7
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRed);
export default __webpack_public_path__ + "static/media/iconRed.af169a2c7b198812a51cc0aa02387432.svg";
export { ForwardRef as ReactComponent };